import { Component, Prop, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'lar-2n-commander-door-content',
  shadow: false,
  scoped: false
})
export class TwoNCommanderDoorContent {
   @Prop() color?: Color;
   @Prop() disabled?: boolean;
   @Prop() value: string;
   @Prop() icon: string;

   render() {
    return [
      <lar-button disabled={this.disabled} color={this.color}><lar-icon icon={this.icon} /> <lar-translate t={this.value} /></lar-button>
    ];
  }
}
